import { uri } from '../constants';
import axios from 'axios';

/**
 * Get release stats with pagination, sorting, and filtering
 * @param {string} userId - The user ID
 * @param {Object} options - Query options for filtering, pagination, and sorting
 * @param {number} options.page - Page number (starting from 1)
 * @param {number} options.limit - Number of items per page
 * @param {string} [options.title] - Filter by exact title match
 * @param {number} [options.minStreams] - Filter by minimum streams
 * @param {number} [options.maxStreams] - Filter by maximum streams
 * @param {number} [options.minRevenue] - Filter by minimum revenue
 * @param {number} [options.maxRevenue] - Filter by maximum revenue
 * @param {string} [options.search] - Search term for partial title matches
 * @param {string} options.sortBy - Sort by field (title, streams, revenue, created_at)
 * @param {string} options.sortOrder - Sort order (asc, desc)
 * @returns {Promise<Object>} - Paginated release stats data
 */
export const getReleaseStats = async (userId, options = {}) => {
  try {
    // Set default values for pagination and sorting
    const queryParams = {
      page: options.page || 1,
      limit: options.limit || 10,
      sortBy: options.sortBy || 'revenue',
      sortOrder: options.sortOrder || 'desc'
    };
    
    // Add optional filter params if provided
    if (options.title) queryParams.title = options.title;
    if (options.minStreams !== undefined) queryParams.minStreams = options.minStreams;
    if (options.maxStreams !== undefined) queryParams.maxStreams = options.maxStreams;
    if (options.minRevenue !== undefined) queryParams.minRevenue = options.minRevenue;
    if (options.maxRevenue !== undefined) queryParams.maxRevenue = options.maxRevenue;
    if (options.search) queryParams.search = options.search;
    
    // Convert query params to URL search params
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      searchParams.append(key, value);
    });
    let url = `${uri}/release_stats/user/${userId}?${searchParams.toString()}`
    if(userId == ''){
      url = `${uri}/release_stats?${searchParams.toString()}`
    }
    const response = await axios.get(url);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching release stats:', error);
    throw error;
  }
};

export const getTrackStats = async (upc) => {
  try {
    const response = await axios.get(`${uri}/release_stats/${upc}/tracks_stat`)
    return response.data.data;
  } catch(ex){
    throw ex;
  }
}